<template>
    <div class="ibox systemlog">
        <div class="ibox-content elevation-4" style="border-radius: 8px;">
            <h2 style="margin: 10px 10px 18px;">{{ translations.title }}</h2>

            <table class="table table-striped table-bordered dataTable dtr-inline systemlog-table">
                <thead>
                    <tr>
                        <th class="col-date">{{ translations.date }}</th>
                        <th class="col-category">{{ translations.category }}</th>
                        <th class="col-type">{{ translations.type }}</th>
                        <th class="col-message">{{ translations.message }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in rows">
                        <td class="col-date">{{ row.date }}</td>
                        <td class="col-category">{{ row.category }}</td>
                        <td class="col-type">{{ row.type }}</td>
                        <td class="col-message" v-html="row.msg"></td>
                    </tr>
                </tbody>
            </table>

            <div class="row no-margins p-h-xs" v-if="hasNoData">
                <div class="col-md-12 text-center">{{ translations.noData }}</div>
            </div>

            <client-detail-pagination
                :page="page"
                :pages="pages"
                event="updateSystemlog"
            />

            <loading :loading="loading"/>
        </div>
    </div>
</template>

<script>
import toaster from "../../common/toaster";
import ClientDetailPagination from "./pagination.vue";
import Loading from "../../common/loading.vue";

export default {
    props: {
        id: {},
        limit: {}
    },
    components: {
        Loading,
        ClientDetailPagination
    },
    data() {
        return {
            rows: {},
            page: 0,
            pages: 0,
            loading: false,
        }
    },
    computed: {
        translations() {
            return {
                title: Lang.langGet("Systemlog"),
                date: Lang.langGet("Date"),
                category: Lang.langGet("Category"),
                type: Lang.langGet("Type"),
                message: Lang.langGet("Message"),
                noData: Lang.langGet("No data available."),
                systemlogLoadError: Lang.langGet("Failed to load latest Systemlog entries!"),
            }
        },
        hasNoData() {
            return Object.keys(this.rows).length === 0;
        }
    },
    methods: {
        load() {
            this.loading = true;
            const data = {
                id: this.id,
                page: this.page,
                limit: this.limit
            };

            axios.post('/system/client-detail/systemlog', data)
                .then(response => {
                    const {rows, pages} = response.data;
                    this.rows = rows;
                    this.pages = pages;
                })
                .catch(error => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.translations.systemlogLoadError);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    mounted() {
        this.load();

        EaseEventBus.listen('updateSystemlog', (data) => {
            this.page = data;
            this.load();
        });
    }
}
</script>

<style scoped>
.systemlog-table {
    table-layout: fixed;
    width: 100%;
}

.systemlog-table .col-date {
    width: 130px;
    white-space: nowrap;
}

.systemlog-table .col-category {
    width: 120px;
    white-space: nowrap;
}

.systemlog-table .col-type {
    width: 120px;
    white-space: nowrap;
}

.systemlog-table .col-message {
    width: auto;
    white-space: normal;
    word-break: break-word;
}
</style>
